import React from 'react';
import { Link } from 'react-router-dom';
import Ax from '../../../components/hoc/Ax';
import { DisplayListPagination } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import TapIcon from '../../../services/TapIcon';
import DateService from '../../../services/DateService';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import ItemDemandDetail from '../../inventory/itemDemand/ItemDemandDetail';
import AllocationDetail from '../../inventory/allocation/AllocationDetail';
import ConsumptionDetailsModal from '../../inventory/consumption/ConsumptionDetailsModal';

function ConsumptionCycleTabUI(props) {
  const {
    demand_listing,
    demandlistingMeta,
    demand_loading,
    allocation_listing,
    allocationlistingMeta,
    allocation_loading,
    consumption_listing,
    consumptionlistingMeta,
    consumption_loading,
    selectedDemandId,
    selectedAllocationId,
    selectedConsumptionId,
    permissions,
    group_permission,
    showOtherDetail,
    default_currency,
    config,
    idValue,
    getDemandList,
    getAllocationList,
    getConsumptionList,
    viewDemandDetail,
    viewAllocationDetail,
    viewConsumptionDetail,
    viewDemandDetailModalRef,
    viewAllocationDetailModalRef,
    viewConsumptionDetailModalRef,
    ticketAllData
  } = props;

  const hasPermission = (permission) => permissions?.includes(permission) || false;
  const hasIscAccess = group_permission?.group_modules?.includes("isc") || false;
  const isTicketDraft = String(ticketAllData?.status_text ?? "").trim().toLowerCase() === "draft";

  const getAddUrlParams = () => {
    const params = {};
    if (config.type === 'ticket') {
      params.ticketId = idValue;
    } else if (config.type === 'sub_assembly') {
      params.subAssemblyId = idValue;
    } 
    return params;
  };

  const renderDemandTable = () => {
    if (!config.showDemand) return null;

    const showDemandAddButton = config.showAddButtons && hasPermission('isc_item_demand_add') && !isTicketDraft;

    return (
      <div className="tab-section">
        <div className="tab_content_wrapper mt-2">
          <span className="content_heading">Item Demand</span>
          {showDemandAddButton && (
            <div className="col-sm-2 text-end">
              <Link
                target="_blank"
                to={{
                  pathname: "/item_demand_add",
                  search: "?" + new URLSearchParams(getAddUrlParams()).toString(),
                }}
              >
                <TapIcon.FontAwesomeIcon icon={TapIcon.faPlus} alt="item-action" />
              </Link>
            </div>
          )}
        </div>

        <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
          {demand_loading ? (
            <tbody>
              <tr><td className="text-center" colSpan={7}><Loader /></td></tr>
            </tbody>
          ) : demand_listing?.length > 0 ? (
            <>
              <thead className="table-secondary">
                {config.showTotalSummary && config.type === 'ticket' && (
                  <tr>
                    <td colSpan={6}><b>Total Demand Qty</b></td>
                    <td className="text-end"> {ticketAllData.total_demands
                                ? ticketAllData.total_demands.total_qty
                                : "-"}</td>
                  </tr>
                )}
                <tr>
                  <th style={{ width: "5%" }}>S.no</th>
                  <th style={{ width: "10%" }}>Date</th>
                  <th style={{ width: "10%" }}>Transaction ID</th>
                  <th style={{ width: "20%" }}>Warehouse</th>
                  <th style={{ width: "35%" }}>Demand For</th>
                  <th style={{ width: "10%" }}>Total Qty</th>
                  <th style={{ width: "10%" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {demand_listing.map((item, index) => (
                  <tr key={index}>
                    <td>{(demandlistingMeta?.from || 0) + index}</td>
                    <td className="text-center">{DateService.dateTimeFormat(item.transaction_date, "DD-MMM-YYYY")}</td>
                    <td className="text-center link-primary" style={{ cursor: "pointer" }}
                      onClick={() => viewDemandDetail(item.transaction_id)}>
                      {item.transaction_id || "-"}
                    </td>
                    <td className="text-capitalize">{item.warehouse?.name || "-"}</td>
                    <td>
                      {item.asset ? (
                        <div>Asset: {item.asset.name} ({item.asset.asset_code})</div>
                      ) : item.workstation ? (
                        <div>Workstation: {item.workstation.workstation_name}</div>
                      ) : item.sub_assembly ? (
                        <div>Sub Assembly: {item.sub_assembly.name}</div>
                      ) : item.employee ? (
                        <div>Employee: {item.employee.name}</div>
                      ) : "-"}
                    </td>
                    <td>{item.total_qty}</td>
                    <td>{item.status?.name || ""}</td>
                  </tr>
                ))}
              </tbody>
            </>
          ) : (
            <tbody>
              <tr><td className="text-center" colSpan={7}>No Records</td></tr>
            </tbody>
          )}
        </table>
        {demand_listing?.length > 0 && (
          <DisplayListPagination
            meta={demandlistingMeta}
            onPageChange={(e) => getDemandList(e.selected + 1)}
          />
        )}
      </div>
    );
  };

  const renderAllocationTable = () => {
    if (!config.showAllocation) return null;

    const showAllocationAddButton = config.showAddButtons && hasPermission('isc-allocation-add') && !isTicketDraft;

    return (
      <div className="tab-section">
        <div className="tab_content_wrapper mt-2">
          <span className="content_heading">Allocation</span>
          {showAllocationAddButton && (
            <div className="col-sm-2 text-end">
              <Link
                target="_blank"
                to={{
                  pathname: "/allocation_list/add",
                  search: "?" + new URLSearchParams(getAddUrlParams()).toString(),
                }}
              >
                <TapIcon.FontAwesomeIcon icon={TapIcon.faPlus} alt="item-action" />
              </Link>
            </div>
          )}
        </div>

        <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
          {allocation_loading ? (
            <tbody>
              <tr><td className="text-center" colSpan={7}><Loader /></td></tr>
            </tbody>
          ) : allocation_listing?.length > 0 ? (
            <>
              <thead className="table-secondary">
                {config.showTotalSummary && config.type === 'ticket' && (
                  <tr>
                  <th colSpan={6}>Total Allocation Qty</th>
                  <td className="text-end"> {ticketAllData.total_allocation
                                ? ticketAllData.total_allocation.total_qty
                                : "-"}</td>
                </tr>
                )}
               
                <tr>
                  <th style={{ width: "5%" }}>S.no</th>
                  <th style={{ width: "15%" }}>Date</th>
                  <th style={{ width: "15%" }}>Transaction ID</th>
                  <th style={{ width: "30%" }}>Warehouse</th>
                  <th style={{ width: "10%" }}>Total Qty</th>
                  <th style={{ width: "10%" }}>Pending Qty</th>
                  <th style={{ width: "15%" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {allocation_listing.map((item, index) => (
                  <tr key={index}>
                    <td>{(allocationlistingMeta?.from || 0) + index}</td>
                    <td className="text-center">{item.transaction_date_display}</td>
                    <td className="text-center link-primary" style={{ cursor: "pointer" }}
                      onClick={() => viewAllocationDetail(item.transaction_id)}>
                      {item.transaction_id || "-"}
                    </td>
                    <td className="text-capitalize">{item.warehouse?.name || "-"}</td>
                    <td className="text-end">{item.total_qty || 0}</td>
                    <td className="text-end">{item.total_pending_qty || 0}</td>
                    <td className="text-center">{item.status_data?.name || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </>
          ) : (
            <tbody>
              <tr><td className="text-center" colSpan={7}>No Records</td></tr>
            </tbody>
          )}
        </table>
        {allocation_listing?.length > 0 && (
          <DisplayListPagination
            meta={allocationlistingMeta}
            onPageChange={(e) => getAllocationList(e.selected + 1)}
          />
        )}
      </div>
    );
  };

  const renderConsumptionTable = () => {
    if (!config.showConsumption) return null;

    const showConsumptionAddButton = config.showAddButtons && hasPermission("isc-consumption-add") && !isTicketDraft;

    return (
      <div className="tab-section">
        <div className="tab_content_wrapper mt-2">
          <span className="content_heading">Consumption</span>
          {showConsumptionAddButton && (
            <div className="col-sm-2 text-end">
              <Link
                target="_blank"
                to={{
                  pathname: "/consumption_list/add",
                  search:
                    "?" + new URLSearchParams(getAddUrlParams()).toString(),
                }}
              >
                <TapIcon.FontAwesomeIcon
                  icon={TapIcon.faPlus}
                  alt="item-action"
                />
              </Link>
            </div>
          )}
        </div>

        <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
          {consumption_loading ? (
            <tbody>
              <tr>
                <td className="text-center" colSpan={7}>
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : consumption_listing?.length > 0 ? (
            <>
              <thead className="table-secondary">
                {config.showTotalSummary && config.type === "ticket" && (
                  <tr>
                    <td colSpan={4}>
                      <b>Total Consumption Qty/Amount</b>
                    </td>
                    <td className="text-end">{ticketAllData.total_consumption
                                    ? ticketAllData.total_consumption.total_qty
                                    : "-"}</td>
                    
                  </tr>
                )}

                <tr>
                  <th style={{ width: "5%" }}>S.no</th>
                  <th style={{ width: "15%" }}>Date</th>
                  <th style={{ width: "15%" }}>Transaction ID</th>
                  <th style={{ width: "30%" }}>Warehouse</th>
                  <th style={{ width: "10%" }}>Total Qty</th>
                  <th style={{ width: "10%" }}>Amount</th>
                  <th style={{ width: "15%" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {consumption_listing.map((item, index) => (
                  <tr key={index}>
                    <td>{(consumptionlistingMeta?.from || 0) + index}</td>
                    <td className="text-center">
                      {item.transaction_date_display}
                    </td>
                    <td
                      className="text-center link-primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => viewConsumptionDetail(item.transaction_id)}
                    >
                      {item.transaction_id || "-"}
                    </td>
                    <td className="text-capitalize">
                      {item.warehouse?.name || "-"}
                    </td>
                    <td className="text-end">{item.total_qty || 0}</td>
                    <td className="text-end">
                      {item.total_amount ? (
                        <CurrencyFormatter
                          currencyCode={default_currency}
                          amount={parseFloat(item.total_amount).toFixed(2)}
                        />
                      ) : (
                        0
                      )}
                    </td>
                    <td className="text-center">
                      {item.status_data?.name || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </>
          ) : (
            <tbody>
              <tr>
                <td className="text-center" colSpan={7}>
                  No Records
                </td>
              </tr>
            </tbody>
          )}
        </table>
        {consumption_listing?.length > 0 && (
          <DisplayListPagination
            meta={consumptionlistingMeta}
            onPageChange={(e) => getConsumptionList(e.selected + 1)}
          />
        )}
      </div>
    );
  };

  const renderModals = () => {
    if (showOtherDetail !== "Y") return null;

    return (
      <>
        <div className="modal fade" id="viewDemandDetailModal" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Demand Details</h5>
                <button type="button" className="btn btn-secondary" onClick={() => viewDemandDetailModalRef?.current?.hide()}>
                  Close
                </button>
              </div>
              <div className="modal-body">
                <ItemDemandDetail demandId={selectedDemandId} />
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="viewAllocationDetailModal" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Allocation Detail</h5>
                <button type="button" className="btn btn-secondary" onClick={() => viewAllocationDetailModalRef?.current?.hide()}>
                  Close
                </button>
              </div>
              <div className="modal-body">
                <AllocationDetail allocationId={selectedAllocationId} />
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="viewConsumptionDetailModal" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Consumption Details</h5>
                <button type="button" className="btn btn-secondary" onClick={() => viewConsumptionDetailModalRef?.current?.hide()}>
                  Close
                </button>
              </div>
              <div className="modal-body">
                <ConsumptionDetailsModal consumptionId={selectedConsumptionId} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  if (!hasIscAccess) return null;

  return (
    <Ax>
      {renderDemandTable()}
      {renderAllocationTable()}
      {renderConsumptionTable()}
      {renderModals()}
    </Ax>
  );
}

export default ConsumptionCycleTabUI;